import axios from "axios";
import { getcusBill, getsupBill } from "./AccountApiServices";
import { getCustomersList, getSupplierList } from "./MasterApiServices";

// const base_path = getBaseUrl();
const base_path = window.APP_CONFIG?.BASE_URL;
// const base_path = process.env.REACT_APP_API_URL;

//get all reports
export const getSalesReport = async ({
  DatatablePagingParameters,
  Filters,
}) => {
  var criteriaJsonString = JSON.stringify({
    DatatablePagingParameters,
    Filters,
  });

  const response = await axios.get(
    `${base_path}/Api/Reports/SalesReport/GetAllLazyPagedData?criteria=${encodeURIComponent(criteriaJsonString)}`
  );
  return response;
};
// the four profit reports: report = DatewiseProfitReport | ItemwiseProfitReport |
// CategorywiseProfitReport | GroupwiseProfitReport; same criteria as the Sales report
export const getProfitReport = async (report, { DatatablePagingParameters, Filters }) => {
  var criteriaJsonString = JSON.stringify({
    DatatablePagingParameters,
    Filters,
  });

  const response = await axios.get(
    `${base_path}/Api/Reports/${report}/GetAllLazyPagedData?criteria=${encodeURIComponent(criteriaJsonString)}`
  );
  return response;
};
//get all status reports
export const getSalesStatusReport = async ({
  DatatablePagingParameters,
  Filters,
}) => {
  var criteriaJsonString = JSON.stringify({
    DatatablePagingParameters,
    Filters,
  });

  const response = await axios.get(
    `${base_path}/Api/Reports/SalesStatusReport/GetAllLazyPagedData?criteria=${encodeURIComponent(criteriaJsonString)}`
  );
  return response;
};
export const getitemWiseSalesReport = async ({
  DatatablePagingParameters,
  Filters,
}) => {
  var criteriaJsonString = JSON.stringify({
    DatatablePagingParameters,
    Filters,
  });

  const response = await axios.get(
    `${base_path}/Api/Reports/ItemWiseSalesReport/GetAllLazyPagedData?criteria=${encodeURIComponent(criteriaJsonString)}`
  );
  return response;
};
export const getSalesAuditReport = async ({
  DatatablePagingParameters,
  Filters,
}) => {
  var criteriaJsonString = JSON.stringify({
    DatatablePagingParameters,
    Filters,
  });

  const response = await axios.get(
    `${base_path}/Api/Reports/SalesLogReport/GetAllLazyPagedData?criteria=${encodeURIComponent(criteriaJsonString)}`
  );
  return response;
};

export const getCategoryWiseReport = async ({
  DatatablePagingParameters,
  Filters,
}) => {
  var criteriaJsonString = JSON.stringify({
    DatatablePagingParameters,
    Filters,
  });

  const response = await axios.get(
    `${base_path}/Api/Reports/SalesItemSummaryReport/GetAllLazyPagedData?criteria=${encodeURIComponent(criteriaJsonString)}`
  );
  return response;
};

export const getConsolidatedReportSectionwise = async ({
  DatatablePagingParameters,
  Filters,
}) => {
  var criteriaJsonString = JSON.stringify({
    DatatablePagingParameters,
    Filters,
  });

  const response = await axios.get(
    `${base_path}/Api/Reports/SalesReportConsol/GetAllLazyPagedData?criteria=${encodeURIComponent(criteriaJsonString)}`
  );

  return response;
};

//itemwise
export const getConsolidatedReportItemwise = async ({
  DatatablePagingParameters,
  Filters,
}) => {
  var criteriaJsonString = JSON.stringify({
    DatatablePagingParameters,
    Filters,
  });

  const response = await axios.get(
    `${base_path}/Api/Reports/ItemWiseConsolReport/GetAllLazyPagedData?criteria=${encodeURIComponent(criteriaJsonString)}`
  );

  return response;
};
//itemwise summary sales
export const getSummReportItemwise = async ({
  DatatablePagingParameters,
  Filters,
}) => {
  var criteriaJsonString = JSON.stringify({
    DatatablePagingParameters,
    Filters,
  });

  const response = await axios.get(
    `${base_path}/Api/Reports/SalesItemSummaryReport/GetAllLazyPagedData?criteria=${encodeURIComponent(criteriaJsonString)}`
  );

  return response;
};

//timebasedreport
export const getTimeBasedReport = async ({
  DatatablePagingParameters,
  Filters,
}) => {
  var criteriaJsonString = JSON.stringify({
    DatatablePagingParameters,
    Filters,
  });

  const response = await axios.get(
    `${base_path}/Api/Reports/SalesReportTimeBased/GetAllLazyPagedData?criteria=${encodeURIComponent(criteriaJsonString)}`
  );

  return response;
};
export const getstockin = async ({ DatatablePagingParameters, Filters }) => {
  var criteriaJsonString = JSON.stringify({
    DatatablePagingParameters,
    Filters,
  });

  const response = await axios.get(
    `${base_path}/Api/Reports/StockInReport/GetAll?criteria=${encodeURIComponent(criteriaJsonString)}`
  );
  return response;
};
export const getstockout = async ({ DatatablePagingParameters, Filters }) => {
  var criteriaJsonString = JSON.stringify({
    DatatablePagingParameters,
    Filters,
  });

  const response = await axios.get(
    `${base_path}/Api/Reports/StockOutReport/GetAll?criteria=${encodeURIComponent(criteriaJsonString)}`
  );
  return response;
};
export const getledgerreport = async ({
  DatatablePagingParameters,
  Filters,
}) => {
  var criteriaJsonString = JSON.stringify({
    DatatablePagingParameters,
    Filters,
  });
  const response = await axios.get(
    `${base_path}/Api/Reports/LedgerReport/GetAll?criteria=${encodeURIComponent(criteriaJsonString)}`
  );
  return response;
};
export const getdaybookreport = async ({
  DatatablePagingParameters,
  Filters,
}) => {
  var criteriaJsonString = JSON.stringify({
    DatatablePagingParameters,
    Filters,
  });
  const response = await axios.get(
    `${base_path}/Api/Reports/DayBook/GetAll?criteria=${encodeURIComponent(criteriaJsonString)}`
  );
  return response;
};
export const getstockvalue = async ({ DatatablePagingParameters, Filters }) => {
  var criteriaJsonString = JSON.stringify({
    DatatablePagingParameters,
    Filters,
  });
  const response = await axios.get(
    `${base_path}/Api/Reports/StockValueReport/GetAll?criteria=${encodeURIComponent(criteriaJsonString)}`
  );
  return response;
};
export const getcustomerstatement = async ({
  DatatablePagingParameters,
  Filters,
}) => {
  var criteriaJsonString = JSON.stringify({
    DatatablePagingParameters,
    Filters,
  });
  const response = await axios.get(
    `${base_path}/Api/Reports/Customer/GetAllCustomerStatement?criteria=${encodeURIComponent(criteriaJsonString)}`
  );
  return response;
};
export const getsupstatement = async ({
  DatatablePagingParameters,
  Filters,
}) => {
  var criteriaJsonString = JSON.stringify({
    DatatablePagingParameters,
    Filters,
  });
  const response = await axios.get(
    `${base_path}/Api/Reports/Supplier/GetAllSupplierStatement?criteria=${encodeURIComponent(criteriaJsonString)}`
  );
  return response;
};
export const getPandLreport = async ({
  DatatablePagingParameters,
  Filters,
}) => {
  var criteriaJsonString = JSON.stringify({
    DatatablePagingParameters,
    Filters,
  });
  const response = await axios.get(
    `${base_path}/Api/FinalAccounts/GetTradingPandL?criteria=${encodeURIComponent(criteriaJsonString)}`
  );
  return response;
};

export const getTrialBalReport = async ({
  DatatablePagingParameters,
  Filters,
}) => {
  var criteriaJsonString = JSON.stringify({
    DatatablePagingParameters,
    Filters,
  });
  const response = await axios.get(
    `${base_path}/Api/FinalAccounts/GetTrialBalance?criteria=${encodeURIComponent(criteriaJsonString)}`
  );
  return response;
};

export const getBalanceSheetReport = async ({
  Filters,
  DatatablePagingParameters,
}) => {
  var criteriaJsonString = JSON.stringify({
    Filters,
    DatatablePagingParameters,
  });
  const response = await axios.get(
    `${base_path}/Api/FinalAccounts/GetBalanceSheetData?criteria=${encodeURIComponent(criteriaJsonString)}`
  );
  return response;
};

export const getAllAccountType = async () => {
  try {
    const response = await axios.get(`${base_path}/Api/AccountType/GetAll`);
    return response;
  } catch (error) {
    console.error("Error fetching account types:", error);
    throw error; // rethrow if needed for handling upstream
  }
};

// Open bills of every customer ("customer") or supplier ("supplier") of a
// branch - the Receivables / Payables / Customer Debits / Supplier Credits
// reports. There is no single outstanding endpoint yet, so this walks the
// party list and asks the bill-wise receipt / payment endpoints (the same ones
// the Bill-wise Receipt / Payment screens use) for each party's open bills.
// One call per party: see docs/BACKEND-COMPLETE.md for the endpoint that
// should replace it. Resolves to { rows: [{ party, bills }], failed, parties };
// a party whose call fails is counted in `failed` rather than failing the report.
export const getOutstandingBills = async ({ party, branch }) => {
  const isCustomer = party === "customer";
  const list = isCustomer ? await getCustomersList(branch) : await getSupplierList();
  const parties = (Array.isArray(list) ? list : []).filter((p) => p && p.guid && !p.isDeleted);
  const getBills = isCustomer ? getcusBill : getsupBill;

  const out = [];
  let failed = 0;
  const queue = [...parties];
  const worker = async () => {
    while (queue.length) {
      const p = queue.shift();
      try {
        const res = await getBills(p.guid, branch);
        const bills = Array.isArray(res?.data) ? res.data : [];
        if (bills.length) out.push({ party: p, bills });
      } catch (e) {
        failed += 1;
      }
    }
  };
  // a few parties at a time, not one request per party all at once
  await Promise.all(Array.from({ length: Math.min(6, parties.length) }, worker));
  return { rows: out, failed, parties: parties.length };
};

export const getPayInOutReport = async ({
  DatatablePagingParameters,
  Filters,
}) => {
  var criteriaJsonString = JSON.stringify({
    DatatablePagingParameters,
    Filters,
  });

  const response = await axios.get(
    `${base_path}/Api/Reports/PayInOutReport/GetAllLazyPagedData?criteria=${encodeURIComponent(criteriaJsonString)}`
  );
  return response;
};

// Stock Summary (handover 28 Oct, RP-ST-8): per product and branch for the
// period - openingBalance, totalIn, totalOut, closingQty and the movement split.
export const getStockSummary = async ({ DatatablePagingParameters, Filters }) => {
  const criteriaJsonString = JSON.stringify({ DatatablePagingParameters, Filters });
  const response = await axios.get(
    `${base_path}/Api/Reports/StockSummaryReport/GetAll?criteria=${encodeURIComponent(criteriaJsonString)}`
  );
  return response;
};
